export class Images {
    public static LOGO = `assets/images/logo.svg`;
    public static ARROW = `assets/images/arrow.svg`;
    public static PINK_ARROW = `assets/images/pink-arrow.svg`;
    public static FACEBOOK = `assets/images/facebook.svg`;
    public static INSTAGRAM = `assets/images/instagram.svg`;
    public static LINKEDIN = `assets/images/linkedin.svg`;
    public static YOUTUBE = `assets/images/youtube.svg`;
    public static CHECK = `assets/images/check.svg`;
    public static BACK = `assets/images/back.svg`;
    public static ERROR = `assets/images/error.svg`;
    public static SUCCESS = `assets/images/success.svg`;
}
